import { apiV3 } from "../axios";

export function getDuvidasFrequentes() {
    return apiV3.get('/duvidas-frequentes');
}

export function rateDuvidaFrequente(id: number, util: boolean) {
    return apiV3.post(`/duvidas-frequentes/avaliacao?id=${id}&util=${util}`);
}